import { Stack, Typography } from "@mui/material";
import compInfos from "./dashboard-page.json";
import { useLangContext } from "../../context/langContext";
import DashboardInfoCardComponent from "../../components/panel/dashboard-board/DashboardInfoCard";
import { routerPaths } from "../../constants/Paths";

export default function DashboardPage() {
  const { lang } = useLangContext();
  const infos = compInfos[lang];
  return (
    <Stack
      width="100%"
      direction="column"
      alignItems={{ md: "start", xs: "center" }}
      justifyContent="start"
      px={{ xs: "8px", md: "20px" }}
    >
      <Typography
        variant="h4DemiBold"
        color={({ palette }) => palette.dominant.main}
        sx={{
          mb: "8px",
          mt: { xs: "0px", sm: "24px" },
        }}
      >
        {infos.title}
      </Typography>
      <Typography
        variant="captionMediumBold"
        color={({ palette }) => palette.dominant[400]}
        sx={{
          mb: "36px",
        }}
      >
        {infos.description}
      </Typography>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ md: "start", xs: "center" }}
        flexWrap="wrap"
        mx="auto"
        gap="16px"
      >
        {infos.cards.map(({ buttonText, description, icon, title, id }) => (
          <DashboardInfoCardComponent
            id={id}
            key={title}
            Icon={icon}
            title={title}
            description={description}
            buttonText={buttonText}
            link={
              id == "1"
                ? `/${routerPaths.VOICE_BROADCASTS}/create`
                : `/${routerPaths.VOICE_BROADCASTS}`
            }
          />
        ))}
      </Stack>
    </Stack>
  );
}
